<template>
	<div class="vitural-keyboard bg-color-light">
    <!-- <FreeTransform 
      :x="0"
      :y="0"
      :scale-x="1"
      :scale-y="1"
      :width="425"
      :height="300"
      :angle="0"
      :offset-x="0"
      :offset-y="0"
    > -->
  		<div class="vitural-keyboard__list">
  			<a href="javascript:;" @click="setVal('1')">1</a>
  			<a href="javascript:;" @click="setVal('2')">2</a>
  			<a href="javascript:;" @click="setVal('3')">3</a>
  			<a href="javascript:;" @click="setVal('4')">4</a>
  			<a href="javascript:;" @click="setVal('5')">5</a>
  			<a href="javascript:;" @click="setVal('6')">6</a>
  			<a href="javascript:;" @click="setVal('7')">7</a>
  			<a href="javascript:;" @click="setVal('8')">8</a>
  			<a href="javascript:;" @click="setVal('9')">9</a>
  			<a href="javascript:;" @click="setVal('0')">0</a>
  			<a href="javascript:;" @click="setVal('>')">></a>
  			<a href="javascript:;" @click="setVal('<')"><</a>
  			<a href="javascript:;" @click="setVal('=')">=</a>
  			<a href="javascript:;" @click="setVal('+')">+</a>
  			<a href="javascript:;" @click="setVal('-')">-</a>
  		</div>
    <!-- </FreeTransform> -->
		<!-- <div class="vitural-keyboard__list vitural-keyboard__list--2">
			<a href="javascript:;" class="btn-err" @click="handleClear">Xóa</a>
			<a href="javascript:;" @click="handleDone">Hoàn thành</a>
		</div> -->
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { STORE_KEY } from './_store/constants'
  // import FreeTransform from 'vue-free-transform'

	export default {
		name: 'VituralKeyboard',
    components: {
      // FreeTransform
    },
		data () {
			return {
			}
		},
		computed: {
			...mapState(STORE_KEY, ['valVituralKeyboard', 'textSelectedData'])
		},
		methods: {
			...mapActions(STORE_KEY, ['setVituralKeyVal']),

			setVal (value) {
        let valTxt = ''
        if (this.textSelectedData && this.textSelectedData.length > 0) {
          valTxt = this.textSelectedData[0] + value + this.textSelectedData[1]
        } else {
          valTxt = this.valVituralKeyboard.val ? this.valVituralKeyboard.val + value : value
        }
        // console.log('Set val: ', value, this.valVituralKeyboard);
				// console.log(this.valVituralKeyboard);
				this.setVituralKeyVal({
					...this.valVituralKeyboard,
					val: valTxt
				});
			},

			handleClear() {

			},

			handleDone() {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.vitural-keyboard {
	position: fixed;
    top: 65%;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 425px;
    margin: auto;
    box-shadow: 0px 0px 6px rgba(0,0,0,.1);
    padding: 20px 15px 10px;

	    &.open-cat {
	    	left: 14%;
	    }

	    &.over-height {
	    	top: 20%;
	    }

	    &.open-sidebar {
	    	right: 20%;
	    }

	    &__list {
		    display: flex;
		    flex-wrap: wrap;

			a {
				width: calc(100% / 5.61);
				@extend .font-sanpro-semibold;
				@extend .text-center;
				@extend .font-size-22;
				@extend .border-rd-4;
				margin-bottom: 10px;

				&:not(.btn-err) {
					@extend .btn-main-light;
				}

				&:not(:nth-child(5n+5)) {
					margin-right: 10px;
				}
			}

			&--2 {
				a {
					width: calc(100% /2.15)
				}
			}
	    }

	}
</style>